import { useNavigate } from 'react-router-dom';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { useModifierKeysDown } from 'shared/hooks/use-modifier-keys-down';
import { Paths } from 'shared/routes';
import { targetIsInput } from 'shared/utils/target-is-input';

import { useToggleSideNav } from './use-toggle-side-nav';

export const useKeyboardShortcuts = () => {
  const navigate = useNavigate();
  const { toggle: toggleSideNav } = useToggleSideNav();

  const _navGenerator = (path: Paths) => (e: KeyboardEvent) => {
    if (targetIsInput(e.target)) {
      return; // Don't open dialog
    }
    navigate(path);
  };

  useModifierKeysDown('Slash', (e) => {
    if (!window.electron || targetIsInput(e.target)) {
      return; // Don't open dialog
    }
    toggleSideNav();
  });
  useKeysDown(['Slash'], (e) => {
    if (window.electron || targetIsInput(e.target)) {
      return; // Don't open dialog
    }
    toggleSideNav();
  });

  useKeysDown(['KeyG', 'KeyI'], _navGenerator(Paths.Inbox), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyT'], _navGenerator(Paths.Home), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyU'], _navGenerator(Paths.Upcoming), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyA'], _navGenerator(Paths.AllTasks), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyC'], _navGenerator(Paths.Completed), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyL'], _navGenerator(Paths.LifeAreas), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyO'], _navGenerator(Paths.Goals), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyH'], _navGenerator(Paths.Habits), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyG', 'KeyN'], _navGenerator(Paths.Insights), {
    otherKeysInCombinationAllowed: true,
  });
};
